import { defineMessages } from "react-intl";

import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";

import CommonFieldName from "./CommonFieldName";
import DateTimeField from "./impl/DateTimeField";
import FieldModel from "./impl/FieldModel";
import { createField } from "./impl/fieldModelUtil";
import UserField from "./impl/UserField";

export enum NoteFieldName {
  CREATOR = "createdBy",
  UPDATED_AT = CommonFieldName.UPDATED_AT,
  NOTE = "note",
}

const displayNames = defineMessages<NoteFieldName>({
  [NoteFieldName.CREATOR]: {
    id: "note.field.folder",
    defaultMessage: "Created By",
    description: "Folder field of note",
  },
  [NoteFieldName.NOTE]: {
    id: "note.field.name",
    defaultMessage: "Note",
    description: "Name field of note",
  },
  [NoteFieldName.UPDATED_AT]: {
    id: "note.field.createdAt",
    defaultMessage: "Updated At",
    description: "Updated At field of note",
  },
});

const noteFieldModel = new FieldModel(
  [
    {
      displayName: displayNames[NoteFieldName.NOTE],
      name: NoteFieldName.NOTE,
      type: FieldType.STRING,
    },
    new UserField({
      displayName: displayNames[NoteFieldName.CREATOR],
      name: NoteFieldName.CREATOR,
    }),
    new DateTimeField({
      displayName: displayNames[NoteFieldName.UPDATED_AT],
      name: NoteFieldName.UPDATED_AT,
    }),
  ].map(createField)
);

export default noteFieldModel;
